import Auth from '../../modules/auth'

export function AuthPage() {
	return <Auth />
}
